export default [
{
    url: "/",
    name: "Dashboard",
    icon: "mdi mdi-home",
    index: 1
}, {
    url: "/users",
    name: "Users",
    icon: "mdi mdi-account",
    index: 2
}]
